import { BaseClient } from './BaseClient'

export class FaqApi extends BaseClient {
  getFaqSeo = this.createRequest({
    url: '/api/faq-page',
    method: 'get',
  })

  getQuestions = ({ name, params }) => {
    return this.createRequest({
      url: `/api/faqs?filters[type][$eq]=${name}`,
      method: 'get',
      params,
    })()
  }
}
